import '@polymer/polymer/lib/elements/dom-if.js';
import '@polymer/iron-form/iron-form.js';

/**
 * Extends the iron-form element, allowing functionality to be added.
 */
const IronForm = customElements.get('iron-form');

export class NsForm extends IronForm {
    static get is() {
        return 'ns-form';
    }

    ready() {
        super.ready();
    }
}

customElements.define(NsForm.is, NsForm);
